import { Text, Link as PrimerLink } from '@primer/components';
import { FileCodeIcon, CodeIcon } from '@primer/styled-octicons';
import { Link } from 'gatsby';
import { SourceLink } from "../../../../src/components";
import * as React from 'react';
export default {
  Text,
  PrimerLink,
  FileCodeIcon,
  CodeIcon,
  Link,
  SourceLink,
  React
};